/*
 * File: DefaultRedirect.js
 * Project: mp-mobile-app
 *
 * Created by Cole on 06/04/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Components for Redirecting to the user's selected default view. Use DefaultRedirect when conditional rendering can be used to navigate, and use DefaultLink when routing to the default view in response to a user action.
 */

import React from "react";
import Preferences from "services/preferences/Store";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { useStore } from "utils/useStore";

export const findRedirect = preferencesStore => {
  let defaultView = preferencesStore.get("defaultView");
  let redirect;
  switch (defaultView) {
    case 0:
      redirect = "dashboard";
      break;
    case 1:
      redirect = "appointments";
      break;
    case 2:
      redirect = "orders";
      break;
    case 3:
      redirect = "patients";
      break;
    case 4:
      redirect = "referrals";
      break;
    default:
      redirect = "dashboard";
      break;
  }
  return "/" + redirect;
};

const DefaultRedirect = () => {
  const preferencesStore = useStore(Preferences);
  return <Redirect to={findRedirect(preferencesStore)} />;
};

export const DefaultLink = ({ children }) => {
  const preferencesStore = useStore(Preferences);
  return <Link to={findRedirect(preferencesStore)}>{children}</Link>;
};

DefaultLink.propTypes = {
  children: PropTypes.array
};

export default DefaultRedirect;
